<template>
  <div class="input-modal-wrapper">
    <div class="input-modal" :class="{'input-modal-600': isComingFromCompany}">
      <form>
        <!-- INPUT -->
        <div v-if="isComingFromCompany">
          <label for="editInputField" class="input-label"></label>
          <div class="input-wrapper">
            <span class="mck">Z</span>
            <input
              id="editInputField"
              type="text"
              :placeholder="placeholder || 'Нова стойност'"
              v-model="input"
              @keydown.enter.prevent="save()"
            />
          </div>
        </div>

        <div class="inputs" :class="{ 'hide': this.isComingFromCompany }">
          <!-- INPUT MATERIAL  -->
          <!-- TODO: refactor to one input only -->
          <div class="input-wrapper" v-if="isComingFromMaterials">
            <span class="mck">U</span>
            <input
              id="inputMaterialField"
              type="text"
              placeholder="Материал"
              v-model="inputName"
              @keydown.enter.prevent="saveMaterialOrActivity()"
            />
          </div>

          <!-- INPUT ACTIVITY  -->
          <div class="input-wrapper" v-if="isComingFromActivities">
            <span class="mck">U</span>
            <input
              id="inputActivityField"
              type="text"
              placeholder="Дейност"
              v-model="inputName"
              @keydown.enter.prevent="saveMaterialOrActivity()"
            />
          </div>

          <!-- INPUT MECHANIZATION  -->
          <div class="input-wrapper" v-if="isComingFromMechanizations">
            <span class="mck">U</span>
            <input
              id="inputMechanizationField"
              type="text"
              placeholder="Механизация"
              v-model="inputName"
              @keydown.enter.prevent="saveMaterialOrActivity()"
            />
          </div>

          <!-- COMMON INPUTS -->
          <div
            class="input-wrapper"
            v-if="isComingFromMaterials || isComingFromActivities || isComingFromMechanizations"
          >
            <span class="mck">Z</span>
            <input
              id="inputUnitField"
              type="text"
              placeholder="Мерна единица"
              v-model="inputUnit"
              :disabled="isComingFromMechanizations"
              @keydown.enter.prevent="saveMaterialOrActivity()"
            />
          </div>
          <div class="input-wrapper" v-if="isComingFromMechanizations || isComingFromMaterials">
            <span class="mck">Z</span>
            <input
              id="inputUnitField"
              type="number"
              placeholder="Цена"
              v-model="inputPrice"
              @keydown.enter.prevent="saveMaterialOrActivity()"
            />
          </div>
        </div>

        <div class="input-modal-actions">
          <div>
            <!-- JUST AND EMPTY DIV FOR THE SPACE-BETWEEN RULE TO WORK -->
          </div>
          <div class="btns">
            <button class="btn btn-close" @click.prevent="close()">
              <span class="mck">F</span>
              Отказ
            </button>
            <!-- BUTTON ACCEPT FOR COMPANY/PROJECT/OBJECT/PART-->
            <button
              v-if="isComingFromCompany"
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="save()"
            >
              <span class="mck">c</span>
              Редактирай
            </button>
            <!-- BUTTON ACCEPT FOR MATERIAL/ACTIVITY-->
            <button
              v-if="isComingFromActivities || isComingFromMaterials || isComingFromMechanizations"
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="saveMaterialOrActivity()"
            >
              <span class="mck">Y</span>
              Запази
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'inputForEdit',
    'isComingFromActivities',
    'isComingFromMaterials',
    'isComingFromMechanizations',
    'isComingFromCompany',
    'placeholder',
    'customWarning',
  ],
  data() {
    return {
      input: '',
      inputName: undefined,
      inputUnit: undefined,
      inputPrice: undefined
    };
  },
  methods: {
    // SAVE METHODS
    save() {
      if (!this.input) {
        this.$snotify.error(`Моля, въведете ${this.customWarning || 'стойност'}`);
      } else {
        this.$parent.$emit('saveEditInputModal', {
          value: this.input,
          where: this.inputForEdit.where
        });
        this.$emit('save', {
          value: this.input,
          where: this.inputForEdit.where
        });
        // this.$snotify.success("Успешно редактиране!");
      }
    },
    saveMaterialOrActivity() {
      if (this.inputValidatation()) {
        this.$parent.$emit('saveMaterialOrActivity', {
          name: this.inputName,
          unit: this.inputUnit,
          price: this.inputPrice || 0,
          isAdditional: true,
          isSelected: true
        });
        this.close();
      }
    },
    // VALIDATE INPUTS
    inputValidatation() {
      if (!this.inputName) {
        let name = 'механизация';
        if (this.isComingFromActivities) {
          name = 'дейност';
        } else if (this.isComingFromMaterials) {
          name = 'материал';
        }
        this.$snotify.error(`Въведете ${name}`);
        return false;
      }
      if (!this.inputUnit) {
        this.$snotify.error('Въведете мерна единица');
        return false;
      }
      // if (this.inputPrice === undefined) {
      //   this.$snotify.error('Въведете цена');
      //   return false;
      // }
      if (this.inputName && this.inputUnit) {
        // && this.inputPrice !== undefined
        return true;
      }
    },
    close() {
      this.$parent.$emit('closeEditInputModal');
      //
      this.$emit('close');
    },
    escape(e) {
      if (e.code === 'Escape') {
        this.close();
      }
    }
  },
  mounted() {
    if (this.isComingFromCompany) {
      this.input = this.inputForEdit.value;
    } else if (this.isComingFromMechanizations) {
      this.inputUnit = 'мсм';
    }
    window.addEventListener('keydown', this.escape);
  },
  destroyed() {
    window.removeEventListener('keydown', this.escape);
  }
};
</script>

<style scoped>
.input-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
.input-modal {
  background-color: #fff;
  border-radius: 4px;
  /* border-top: 10px solid var(--color-main); */
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
  padding: 10px 20px 0;
}
.input-modal-600 {
  width: 600px;
}
.input-modal-permissions {
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.input-modal-actions {
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.invalid .mck {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.inputs {
  display: flex;
  margin-top: 20px;
}
.input-wrapper {
  margin-right: 1em;
  margin-bottom: 1em;
}
.input-wrapper:last-child {
  margin-right: 0px;
  /* margin-bottom: 0px; */
}
.hide {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .btn.btn-close {
    margin-bottom: 5px;
  }
}
@media screen and (max-width: 650px) {
  .input-modal {
    width: 90%;
  }
}
@media screen and (max-width: 450px) {
  .inputs {
    flex-direction: column;
  }
  .input-wrapper {
    margin-right: 0px;
  }
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-close {
    margin-bottom: 10px;
  }
}
</style>
